import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
let Department = class Department extends Vue {
  // eslint-disable-next-line
  watchIndex() {}
  dataChage(value) {
    console.log("item---", value);
  }
};
__decorate([Prop({
  type: Number,
  default: 0
})], Department.prototype, "zIndex", void 0);
__decorate([Watch("zIndex", {
  immediate: true
})], Department.prototype, "watchIndex", null);
__decorate([Prop({
  type: Object,
  default: {}
})], Department.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], Department.prototype, "dataChage", null);
Department = __decorate([Component({
  name: "department"
})], Department);
export default Department;